import type FocusedViewFilter from 'owa-service/lib/contract/FocusedViewFilter';
import getFocusedFilterForTable from 'mini-mail-list-store/lib/utils/getFocusedFilterForTable';
import getSelectedTableView from 'mini-mail-list-store/lib/utils/getSelectedTableView';
import { getFolderName } from 'mini-mail-list-store/lib/selectors/getFolderName';
import { isMiniFeatureEnabled } from 'owa-mini-feature-flags';
import { isMiniHostAppFeatureEnabled } from 'mini-hostapp-feature-flags/lib/isMiniHostAppFeatureEnabled';

/**
 * Returns if Ads component can be rendered in the mail list-view.
 * Outlook Lite we don't show ads in the focused view.
 * @param nativeAdFormat
 * @param isInMultiSelectMode
 * @returns
 */
export const canShowAdsComponentInListView = (isInMultiSelectMode: boolean = false) => {
    if (isInMultiSelectMode) {
        return false;
    }

    const tableView = getSelectedTableView();
    const focusedViewFilter = getFocusedFilterForTable(tableView);

    if (focusedViewFilter === 0) {
        return isMiniHostAppFeatureEnabled('adsInFocussedInbox');
    }

    // temporary variable to check is Ads in Primary for Lite is enabled
    // is ads in primary for lite enabled
    // if the folder is inbox to show ads in primary inbox only
    // if any of the 3 treatment are enabled, we should show ads in Primary
    const showAdsInLitePrimary =
        isMiniHostAppFeatureEnabled('adsInLitePrimary') &&
        getFolderName() === 'inbox' &&
        (isMiniFeatureEnabled('lite-PrimaryAndCustomInboxAds-1stPosition-treatment') ||
            isMiniFeatureEnabled('lite-PrimaryAndCustomInboxAds-2ndPosition-treatment') ||
            isMiniFeatureEnabled('lite-PrimaryAndCustomInboxAds-3rdPosition-treatment'));

    // show ads in primary/custom inbox only if the feature is enabled
    if (focusedViewFilter === -1) {
        return showAdsInLitePrimary ? true : isMiniHostAppFeatureEnabled('adsInFocussedInbox');
    }

    return true;
};
